import { Injectable } from '@angular/core';
import { FormControl, ValidationErrors, AbstractControl } from '@angular/forms';

@Injectable()
export class ValidatorsUtils {
    constructor() {}

    static notEmpty(control: AbstractControl): ValidationErrors | null {
        return !control.value || control.value.trim().length <= 0 ? { notEmpty: true } : null;
    }

    /**
     * Custom validator that ensures password == confirmPassword
     */
    public passwordsMatch(control: FormControl): { [key: string]: any } | null {
        try {
            const confirm = control;
            const password = control.parent.get('password');

            if (password && confirm.value != password.value) {
                return { passwordsMatch: false };
            }

            return null;
        } catch (err) {
            console.log(`Received error while matching password fields: ${err.message}`);
            return null;
        }
    }

    /**
     * Helper method to determine if an input is invalid
     * We must take into account if a field has been touched
     * If a field is invalid but hasn't been touched, we don't
     * necessarily want to show an error right from the start
     */
    public isControlInvalid(control: AbstractControl): boolean {
        return control.invalid && control.touched;
    }
}



// WEBPACK FOOTER //
// ./src/utils/validators.ts